jQuery(function($) {
    const params = new URLSearchParams(window.location.search);
    const fieldFocus = params.get('field_focus');

    if(!fieldFocus) return;

    const field = $('.field[full_field_name="sc-fields[' + fieldFocus + ']"]');

    console.log('field_focus', field);

    if(!field.length) return;

    setTimeout(function () {
        $('html, body').animate({
            scrollTop: field.offset().top - 100
        }, 500);
    
        setTimeout(function () {
            field.addClass('field-focus-highlight');

            if(field.hasClass('wysiwyg')) {
                const textarea = field.find('textarea.wp-editor-area');

                if(textarea.closest('.wp-editor-wrap').hasClass('html-active')) {
                    textarea.focus();
                } else {
                    const editorId = textarea.attr('id');
                    if(editorId && typeof tinymce !== 'undefined') {
                        const editor = tinymce.get(editorId);
                        if(editor) editor.focus();
                    }
                }                
            } else {
                const $input = field.find('input, textarea, select').first();
                if($input.length) $input.trigger('focus');
            }
        }, 500);
    }, 500);
});